import React from 'react'
import TestimonialSlider from './testimonial'
import { useInView } from "react-intersection-observer";


function Restbody() {
  const { ref:myRef, inView:isVisible } = useInView();

  return (
    <div>
      <header class="section__container header__container" id="home">
<div class="header__image">
  <img src='assets/headerImage.avif' alt="header" />
</div>
<div class="header__content">
  <div>
    <h1>We Help You Make Modern Interior</h1>
    <p>
      We will help you to make an elegant and luxurious interior designed
      by professional interior designer.
    </p>
  </div>
</div>
</header>

<section class="section__container deals__container">
<div class="deals__card">
  <h2 class="section__header">Hot  deals for you</h2>
  <p>Online shopping for retail sales direct to consumers</p>
</div>
<div class={isVisible?"deals__card appear":"deals__card"} ref={myRef}>
  <span><i class="ri-cash-line"></i></span>
  <h4>1.5% cashback</h4>
  <p>Earn a 5% cashback reward on every furniture purchase you make!</p>
</div>
<div  class={isVisible?"deals__card appear2":"deals__card"} ref={myRef}>
  <span><i class="ri-calendar-schedule-line"></i></span>
  <h4>30 day terms</h4>
  <p>
    Take advantage of our 30-day payment terms, completely interest-free!
  </p>
</div>
<div class={isVisible?"deals__card appear3":"deals__card"} ref={myRef}>
  <span><i class="ri-money-rupee-circle-line"></i></span>
  <h4>Save money</h4>
  <p>
    Discover unbeatable prices and save big money on top-quality
    furniture!
  </p>
</div>
</section>

<section class="section__container about__container" id="about">
<div class="about__header">
  <div>
    <h2 class="section__header">About us</h2>
    <p class="section__description " id='about-description'>
      Our passion for exceptional craftsmanship drives us to curate the
      best pieces for every room in your house.
    </p>
  </div>
  <button class="about__btn">Learn More</button>
</div>
<div class="about__content">
  <div class="about__image">
    <img src="assets/about.png" alt="about" />
  </div>
  <div class="about__grid">
    <div class={isVisible?" about__card appear":"about__card"} ref={myRef}>
      <h3>1.</h3>
      <h4>Who we are</h4>
      <p>
        You get a 2-week free trail to kick the Smaert tries. We want you
        to.
      </p>
    </div>
    <div class={isVisible?" about__card appear2":"about__card"} ref={myRef}>
      <h3>2.</h3>
      <h4>What do we do</h4>
      <p>
        We give you a free course that guides you through the process.
      </p>
    </div>
    <div class={isVisible?" about__card appear3":"about__card"} ref={myRef}>
      <h3>3.</h3>
      <h4>How do we help</h4>
      <p>Use our multimedis lectures, videos, and coaching sessions.</p>
    </div>
    <div class="about__card">
      <h3>4.</h3>
      <h4>Create success story</h4>
      <p>
        With access to online learning resources anyone can transform.
      </p>
    </div>
  </div>
</div>
</section>

<section class="section__container product__container" id="product">
<h2 class="section__header">Products</h2>
<div class="product__grid" >
  <div  class={isVisible?" product__card appear":"product__card"} ref={myRef}>
    <h4>Stackable Chair</h4>
    <p>$87.00</p>
    <img src="assets/product-1.png" alt="product" loading='lazy' />
  </div>
  <div  class={isVisible?" product__card appear":"product__card"} ref={myRef}>
    <h4>Lamp Tool</h4>
    <p>$35.00</p>
    <img src="assets/product-2.png" alt="product" loading='lazy'/>
  </div>
  <div class={isVisible?" product__card appear":"product__card"} ref={myRef}>
    <h4>Dining Chair</h4>
    <p>$55.00</p>
    <img src="assets/product-3.png" alt="product" loading='lazy'/>
  </div>
  <div class={isVisible?" product__card appear":"product__card"} ref={myRef}>
    <h4>Hand Base Lamp</h4>
    <p>$35.00</p>
    <img src="assets/product-4.png" alt="product" loading='lazy'/>
  </div>
  <div class={isVisible?" product__card appear":"product__card"} ref={myRef}>
    <h4>Stylish Chair</h4>
    <p>$45.00</p>
    <img src="assets/product-5.png" alt="product" loading='lazy'/>
  </div>
  <div class={isVisible?" product__card appear":"product__card"} ref={myRef}>
    <h4>Vintage Chair</h4>
    <p>$65.00</p>
    <img src="assets/product-6.png" alt="product" loading='lazy'/>
  </div>
</div>
</section>

<TestimonialSlider/>

    </div>
  )
}

export default Restbody
